import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadGeneraTabla } from '../../shared/utilities/utilidad-genera-tabla';
import { TablaCatalogoDatos } from '../../shared/entities/tabla-catalogo-datos';
import { MenuEstadistica } from '../../shared/entities/menu-estadistica';
import { DataAccordion } from '../../shared/entities/data-accordion';
import { Constantes } from '../../shared/constant/constantes';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HeaderComponent } from '../../shared/header/header.component';

@Component({
    selector: 'app-catalogo-datos',
    templateUrl: './catalogo-datos.component.html',
    styleUrls: ['./catalogo-datos.component.css'],
    standalone: true,
    imports: [CommonModule, HeaderComponent,RouterModule]
})
export class CatalogoDatosComponent implements OnInit {

    public utilidadTabla: UtilidadGeneraTabla = new UtilidadGeneraTabla();
    public constantes: Constantes = new Constantes();

    public listaCatalogo: Array<MenuEstadistica> = new Array();
    public listaTablaCatalogo: Array<TablaCatalogoDatos> = new Array();

    public listaDataAccordion: Array<DataAccordion> = new Array();
    public isTablaAccordion = false;

    public listaSeriesTasaCambio: Array<any> = new Array();
    public listaSeriesTasaInteres: Array<any> = new Array();
    public listaSeriesPreciosInflacion: Array<any> = new Array();
    public listaSeriesOperBancoReservaInternacional: Array<any> = new Array();
    public listaSeriesActividadEconomica: Array<any> = new Array();

    public mapaSeriesMenu: Map<string, Array<any>> = new Map();

    public mapaIdOptionOpen: Map<number, number> = new Map();

    public tematica: string = '';

    public additionalDataShowChildren: { [key: string]: boolean } = {};

    constructor(private service: VisualizadorService, private router: Router, private route: ActivatedRoute, private location: Location) { }

    ngAfterViewInit(): void {
        if (this.tematica == null) {
            this.service.setWindowScroll(0, 0);
        }
    }

    async ngOnInit(): Promise<void> {
        const currentUrl = this.location.path();
        this.service.generaTagsHtmlSEO('Catálogo de datos','Catálogo de las series mas importantes','catálogo, datos',currentUrl);
        this.tematica = this.route.snapshot.paramMap.get('tematica')!;
        this.generaMenuCatalogoPrincipal();
    }

    //GENERA EL MENU INICIAL
    private async generaMenuCatalogoPrincipal() {
        await this.service.getMenuXOpcion('CATALOGO_DATOS').subscribe({
            next: (listaCatalogoMenu) => {
                this.listaCatalogo = listaCatalogoMenu;
                this.listaTablaCatalogo = this.getTablaCatalogo(listaCatalogoMenu);

                setTimeout(() => {
                    if (this.tematica != null) {
                        this.buscarPalabraTitulo(this.tematica);
                    }
                }, 600);
            },
            error: (error) => {
                console.log("Error inesperado en getMenuXOpcion", error);
            }
        });
    }

    private getTablaCatalogo(listaMenuEstadistica: Array<MenuEstadistica>): Array<TablaCatalogoDatos> {
        let listaResponse: Array<TablaCatalogoDatos> = new Array();
        let opcionCatalogo: TablaCatalogoDatos;
        listaMenuEstadistica.forEach(serieLista => {
            opcionCatalogo = new TablaCatalogoDatos();
            opcionCatalogo = this.utilidadTabla.getObjTablaCatalogo(serieLista.id, opcionCatalogo);
            opcionCatalogo.id = serieLista.id;
            opcionCatalogo.titulo = serieLista.nombre;
            this.additionalDataShowChildren[opcionCatalogo.id] = false;
            if (serieLista.idPadre == 0) {
                let opcionEnlace: MenuEstadistica;
                let listaOpciones: Array<MenuEstadistica> = new Array();
                if (serieLista.menuHijos != undefined && serieLista.menuHijos.length > 0) {
                    serieLista.menuHijos.forEach((serieHijo: MenuEstadistica) => {
                        opcionEnlace = new MenuEstadistica();
                        opcionEnlace = serieHijo;
                        opcionEnlace.estiloClase = this.validaEstiloIconoCatalogo(serieHijo, 1);
                        if (opcionEnlace.menuHijos != undefined && opcionEnlace.menuHijos.length > 0) {
                            opcionEnlace.menuHijos.forEach((hijo) => {
                                hijo.estiloClase = this.validaEstiloIconoCatalogo(hijo, 2);
                            });
                        }
                        listaOpciones.push(opcionEnlace);
                    });
                }
                opcionCatalogo.enlaces = listaOpciones;
            }
            listaResponse.push(opcionCatalogo);
        });
        this.utilidadTabla.ordenaTablaCatalogo(listaResponse);
        return listaResponse;

    }

    private validaEstiloIconoCatalogo(hijo: MenuEstadistica, nivel: number): string {

        var result: string = 'div-li-icon-er-p';
        if (hijo.direccion_a_tabla == 'S') {
            if (nivel == 1) {
                result = 'div-li-icon-tabla-1';
            } else {
                result = 'div-li-icon-tabla-2';
            }
        } else if (hijo.mostrarHijos == 'S') {
            result = 'div-li-icon-ok-p';
        } else {
            if (nivel == 1) {
                result = 'div-li-icon-grafica-1';
            } else {
                result = 'div-li-icon-grafica-2';
            }
        }
        return result;
    }

    public openWindow(fila: any, opcion: TablaCatalogoDatos, filaPapa?: MenuEstadistica) {
        var subtitulo = '';
        var titulo = '';
        titulo = this.eliminarEspaciosTitulos(fila.nombre);
        if(fila.urlAcceso && fila.urlAcceso.trim().length > 0){
            titulo = fila.urlAcceso;
            this.router.navigate(['informacionSerie/', fila.id, titulo]);
        } else {
            opcion.enlaces.forEach(element => {
                if (element.id === fila.idPadre) {
                    titulo = this.eliminarEspaciosTitulos(element.nombre);
                    subtitulo = this.eliminarEspaciosTitulos(fila.nombre);
                } else {
                    if (filaPapa) {
                        titulo = filaPapa.nombre!;
                        subtitulo = this.eliminarEspaciosTitulos(fila.nombre);
                    }
                }
            });
            this.router.navigate(['informacionSerie/', fila.id, titulo, subtitulo]);
        }
        
        //this.router.navigate(['informacionSerie/', fila.id, titulo, subtitulo]);

        
    }

    public findInDashboard(fila: any) {
        this.router.navigate([this.constantes.urlDashboard], { queryParams: { 'idDashboard': fila.enlace_dashboard } });
    }

    public showChildren(opcionCatalogo: TablaCatalogoDatos) {
        this.additionalDataShowChildren[opcionCatalogo.id] = !this.additionalDataShowChildren[opcionCatalogo.id];
    }

    /**********************************************************************/
    /****************RESALTAR LA PALABRA CONSULTADA************************/
    /**********************************************************************/
    public buscarPalabraMenu(value: string) {
        this.mapaIdOptionOpen = new Map();
        var catalogoSelect: Array<MenuEstadistica> = new Array();
        var catalogo = this.utilidadTabla.clonarObjeto(this.listaCatalogo);
        catalogoSelect = this.generaListaBusqueda(catalogo, value);
        this.listaTablaCatalogo = this.getTablaCatalogo(catalogo);
        var idSelect: number = this.mapaIdOptionOpen.values().next().value!;
        var t: string = '';
        this.listaTablaCatalogo.forEach(element => {
            var existe = this.isIdExistInList(element.enlaces, idSelect);
            if (existe) {
                t = 'titulo-' + element.id;
            }
        });
        if (document.querySelector("#" + t) != null) {
            document.querySelector("#" + t)!.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private isIdExistInList(lista: Array<MenuEstadistica>, id: number): boolean {
        return lista.some(element =>
            element.id === id || (element.menuHijos?.some(hijo => hijo && hijo.id === id || false)));
    }

    private generaListaBusqueda(listaCatalogo: Array<MenuEstadistica>, palabra: string): any {
        var listaCoincide = new Array();
        var palabraMinuscula = this.utilidadTabla.validaPalabra(palabra);
        listaCatalogo.forEach((padre: MenuEstadistica) => {
            var isOpcionValida = false;
            var nombrePadreMinus = this.utilidadTabla.validaPalabra(padre.nombre);
            if (this.utilidadTabla.isPalabraCoincide(palabraMinuscula, nombrePadreMinus)) {
                padre.nombre = this.utilidadTabla.resaltarPalabra(palabraMinuscula, padre.nombre);
                isOpcionValida = true;
            }
            if (padre.menuHijos.length > 0) {
                padre.menuHijos.forEach((hijo: MenuEstadistica) => {
                    var nombreHijoMinus = this.utilidadTabla.validaPalabra(hijo.nombre);
                    if (this.utilidadTabla.isPalabraCoincide(palabraMinuscula, nombreHijoMinus)) {
                        hijo.nombre = this.utilidadTabla.resaltarPalabra(palabraMinuscula, hijo.nombre);
                        this.mapaIdOptionOpen.set(hijo.id, hijo.id);
                        isOpcionValida = true;
                    }
                    if (hijo.menuHijos != undefined && hijo.menuHijos.length > 0) {
                        hijo.menuHijos.forEach((nieto: MenuEstadistica) => {
                            var nombreNietoMinus = this.utilidadTabla.validaPalabra(nieto.nombre);
                            if (this.utilidadTabla.isPalabraCoincide(palabraMinuscula, nombreNietoMinus)) {
                                nieto.nombre = this.utilidadTabla.resaltarPalabra(palabraMinuscula, nieto.nombre);
                                this.mapaIdOptionOpen.set(nieto.id, nieto.id);
                                isOpcionValida = true;
                            }
                        });
                    }
                });
            }
            listaCoincide.push(padre);
        });
        return listaCoincide;
    }


    public buscarPalabraTitulo(value: string) {
        var t: string = '';
        this.listaTablaCatalogo.forEach(element => {
            var tituloMinuscula = element.titulo.toLocaleLowerCase();
            var palabraMinuscula = value.toLocaleLowerCase();
            if (tituloMinuscula.includes(palabraMinuscula)) {
                t = 'titulo-' + element.id;
            }
        });
        if (document.querySelector("#" + t) != null) {
            document.querySelector("#" + t)!.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private eliminarEspaciosTitulos(texto: string) {
        var response: string = texto.replaceAll(' ', '_');
        return response;
    }


}
